import  MappingGroup from "./MappingGroup.json";

type MappingGroupType = {
  [key: string]: {
    project: string;
  };
};

export type ProjectsType = {
  key: string;
  name: string;
};

export function getProjects(ids: string[]): ProjectsType[] {
  const projects: ProjectsType[] = [];
  const mappingGroup: MappingGroupType = MappingGroup;
  ids.forEach((id) => {
    if (mappingGroup[id]) {
      projects.push({ key: id, name: mappingGroup[id].project });
    }
  });
  return projects.length ? projects : [];
}
